import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";

const CookieBanner = () => {
    const [choice, setChoice] = useState(
        () => localStorage.getItem("moovie-cookie-consent") || null,
    );

    const decide = (value) => {
        localStorage.setItem("moovie-cookie-consent", value);
        setChoice(value);
    };

    return (
        <AnimatePresence>
            {!choice && (
                <motion.div
                    data-testid="cookie-banner"
                    initial={{ y: 120, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 120, opacity: 0 }}
                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: 1.2 }}
                    className="fixed bottom-5 left-5 right-5 md:right-auto md:max-w-md z-50 bg-cream/95 backdrop-blur-xl border border-linen p-6 shadow-xl shadow-ink/10"
                >
                    <p className="font-serif text-xl text-ink">Una nota sui cookie</p>
                    <p className="mt-2 text-sm text-stone2 leading-relaxed">
                        Usiamo solo cookie tecnici per far funzionare il sito e, previo
                        consenso, strumenti di misurazione anonima. Nessun dato viene
                        venduto a terzi.
                    </p>
                    <div className="mt-4 flex flex-wrap items-center gap-3">
                        <button
                            data-testid="cookie-accept-button"
                            onClick={() => decide("accepted")}
                            className="bg-ink text-cream text-xs tracking-[0.12em] uppercase px-5 py-3 rounded-full hover:bg-sage transition-colors duration-300"
                        >
                            Accetta
                        </button>
                        <button
                            data-testid="cookie-decline-button"
                            onClick={() => decide("necessary")}
                            className="border border-ink/30 text-ink text-xs tracking-[0.12em] uppercase px-5 py-3 rounded-full hover:border-ink transition-colors duration-300"
                        >
                            Solo necessari
                        </button>
                        <Link
                            to="/privacy"
                            data-testid="cookie-privacy-link"
                            className="text-xs text-stone2 underline underline-offset-4 hover:text-ink transition-colors duration-300"
                        >
                            Privacy Policy
                        </Link>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieBanner;
